module.exports = __webpack_public_path__ + "img/logo-bg-center-no-back.4ccfb1a4.png";